import { gql, useMutation } from '@apollo/client'

import {
  CreateOrderFormCustomerShim,
  CustomerInput,
  LineItemInput,
  ShippingCost,
  Address,
} from '../../types'

interface Data {
  createQuote: { id: string }
}

interface Variables {
  stores: { id: string; pickupAddress: Address | null }[]
  notes: string
  customer: CustomerInput | null
  customerShim: CreateOrderFormCustomerShim | null
  shippingCosts: ShippingCost[]
  timingDetails: {
    storeId: string
    timingDetails: string
  }[]
  pickupInputs: {
    storeId: string
    pickup: boolean
  }[]
  payOnAccount: boolean
  payOnInvoice: boolean
  lineItems: LineItemInput[]
  requestForQuoteId: string | null
  allowUnverifiedAddress: boolean
}

const mutation = gql`
  mutation CreateQuote(
    $stores: [CreateQuoteStoreInput]
    $notes: String
    $customer: CreateCustomerInput
    $customerShim: CreateShimInput
    $shippingCosts: [ShippingCostInput]
    $timingDetails: [TimingDetailsInput]
    $pickupInputs: [PickupInput]
    $payOnAccount: Boolean
    $payOnInvoice: Boolean
    $lineItems: [LineItemInput]
    $requestForQuoteId: String
    $allowUnverifiedAddress: Boolean
  ) {
    createQuote(
      stores: $stores
      notes: $notes
      customer: $customer
      customerShim: $customerShim
      lineItems: $lineItems
      shippingCosts: $shippingCosts
      timingDetails: $timingDetails
      pickupInputs: $pickupInputs
      payOnAccount: $payOnAccount
      payOnInvoice: $payOnInvoice
      requestForQuoteId: $requestForQuoteId
      allowUnverifiedAddress: $allowUnverifiedAddress
    ) {
      id
    }
  }
`

const useCreateQuote = () => {
  const [mutate] = useMutation<Data, Variables>(mutation)

  return (variables: Variables) => mutate({ variables })
}

export default useCreateQuote
